import React from 'react'
import { Switch, Route, Redirect, useHistory } from 'react-router-dom'
import PropTypes from 'prop-types'
import ForgotPasswordUI from '../forgotPasswordUI/ForgotPasswordUI'
import UpdatePasswordUI from '../updatePasswordUI/UpdatePasswordUI'
import LogIn from '../logIn/LogIn'
import EditProfileUI from '../editProfileUI/EditProfileUI'
import RegisterUI from '../registerUI/RegisterUI'
import ChangePasswordUI from '../changePasswordUI/ChangePasswordUI'
import { ChangePasswordViewModel } from '../../models/ChangePasswordViewModel'
import { UserProfileDataViewModel } from '../../models/UserDataViewModel'
import RegisterConfirmationPage from '../registerUI/RegisterConfirmationPage'
import { OktaAuth, toRelativeUrl } from '@okta/okta-auth-js'
import { Security } from '@okta/okta-react'

export default function Wizard( props ) {
    const history = useHistory()

    const config = props.config || {}
    const loginUrl = config.logInUrl || process.env.REACT_APP_LOG_IN
    const forgotPasswordUrl = config.forgotPasswordUrl || process.env.REACT_APP_FORGOT_PASSWORD
    const updatePasswordUrl = config.updatePasswordUrl || process.env.REACT_APP_UPDATE_PASSWORD
    const routeDefaultUrl = config.routeDefaultUrl || process.env.REACT_APP_ROUTE_DEFAULT
    const changePasswordUrl = config.changePasswordUrl || process.env.REACT_APP_CHANGE_PASSWORD
    const editProfileUrl = config.editProfileUrl || process.env.REACT_APP_EDIT_PROFILE
    const registerUrl = config.registerUrl || process.env.REACT_APP_REGISTER
    const registerConfirmationPageUrl = config.registerConfirmationPageUrl || process.env.REACT_APP_REGISTER_CONFIRMATION_PAGE
    
    const oktaAuth = new OktaAuth( {
        clientId: config.oktaClientId || process.env.REACT_APP_OKTA_CLIENT_ID,
        issuer: config.oktaIssuer || process.env.REACT_APP_OKTA_ISSUER,
        redirectUri: `${ window.location.origin }${ process.env.REACT_APP_LOG_IN }`,
        pkce: true,
    } )

    const restoreOriginalUri = async ( _oktaAuth, originalUri ) => {
        history.replace( toRelativeUrl( originalUri || '/', window.location.origin ) )
      }
    return (
        <Security
            oktaAuth={ oktaAuth }
            restoreOriginalUri={ restoreOriginalUri }
        >
            <Switch>
                <Route exact path={ loginUrl } component={ () => <LogIn config={ config } /> } />
                <Route exact path={ forgotPasswordUrl } component={ () => <ForgotPasswordUI config={ config } /> } />
                <Route exact path={ updatePasswordUrl } component={ () => <UpdatePasswordUI config={ config } /> } />
                <Route exact path={ changePasswordUrl } component={ () => <ChangePasswordUI config={ config } /> } />
                <Route exact path={ editProfileUrl } component={ () => <EditProfileUI config={ config } /> } />
                <Route exact path={ registerUrl } component={ () => <RegisterUI config={ config } /> } />
                <Route exact path={ registerConfirmationPageUrl } component={ () => <RegisterConfirmationPage config={ config } /> } />                
                <Route exact path={ routeDefaultUrl }>
                    <Redirect to={ loginUrl } />
                </Route>
                <Route exact path="/">
                    <Redirect to={ loginUrl } />
                </Route>
            </Switch>
        </Security>
    )
}

Wizard.propTypes = {
    config: PropTypes.shape( {
        routeDefaultUrl: PropTypes.string,
        logInUrl: PropTypes.string,
        logInApiUrl: PropTypes.string,
        editProfileUrl: PropTypes.string,
        editProfileApiUrl: PropTypes.string,
        registerUrl: PropTypes.string,
        registerApiUrl: PropTypes.string,
        forgotPasswordUrl: PropTypes.string,
        forgotPasswordApiUrl: PropTypes.string,
        updatePasswordUrl: PropTypes.string,
        updatePasswordApiUrl: PropTypes.string,
        changePasswordUrl: PropTypes.string,
        changePasswordUrlApiUrl: PropTypes.string,
        registerConfirmationPageUrl: PropTypes.string,
        contractorsUrl: PropTypes.string,
        municipalUrl: PropTypes.string,
        dgContractorsUrl: PropTypes.string,
        ReturnUrl: PropTypes.string,
        changePasswordViewModel: PropTypes.instanceOf( ChangePasswordViewModel ),
        userProfileDataViewModel: PropTypes.instanceOf( UserProfileDataViewModel ),
        disablePhoneNumber: PropTypes.bool,
        logOffUrl: PropTypes.string,
        oktaClientId : PropTypes.string,
        oktaIssuer : PropTypes.string,
        oktaRedirectUri : PropTypes.string,
        mfaAskMeAgainTimeOut: PropTypes.number,
        mfaAskMeAgainUrl: PropTypes.string,
        antiForgeryHeaderName: PropTypes.string
    } )
}
